import { render, staticRenderFns } from "./IconShoppingCartOutline.vue?vue&type=template&id=4fa1ee7e"
import script from "./IconShoppingCartOutline.vue?vue&type=script&lang=js"
export * from "./IconShoppingCartOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports